import { render, staticRenderFns } from "./LayoutDefaultNew.vue?vue&type=template&id=796c1527&scoped=true&"
import script from "./LayoutDefaultNew.vue?vue&type=script&lang=js&"
export * from "./LayoutDefaultNew.vue?vue&type=script&lang=js&"
import style0 from "./LayoutDefaultNew.vue?vue&type=style&index=0&id=796c1527&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796c1527",
  null
  
)

export default component.exports